import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { NavbarBrand, Navbar } from "reactstrap";
import { Tabs, Tab } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // Add this in your project if not already included
import "../assets/css/style.css"; // Adjust the path as necessary


const OfficeOrderTable = () => {
  const [officeOrders, setOfficeOrders] = useState([]);
  const [otherAnnouncements, setOtherAnnouncements] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await axios.get("https://admin-panel-z73v.onrender.com/announcements?all=true");
        const sorted = res.data.reverse();

        // Split data into Office Orders and Other Announcements
        const officeOrdersData = sorted
          .filter((item) => item.title?.toLowerCase().startsWith("office order"))
          .map((item) => ({
            ...item,
            link: item.link,
          }));

        const otherAnnouncementsData = sorted
          .filter((item) => !item.title?.toLowerCase().startsWith("office order"))
          .map((item) => ({
            ...item,
            link: item.link,
          }));

        setOfficeOrders(officeOrdersData);
        setOtherAnnouncements(otherAnnouncementsData);
        setIsLoading(false);
      } catch (error) {
        console.error("Failed to fetch announcements:", error);
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const filteredOfficeOrders = officeOrders.filter((item) => {
    const search = filterText.toLowerCase();
    return (
      item.title?.toLowerCase().includes(search) ||
      item.orderNo?.toLowerCase().includes(search) ||
      new Date(item.date).toLocaleDateString().toLowerCase().includes(search)
    );
  });

  const filteredOtherAnnouncements = otherAnnouncements.filter((item) => {
    const search = filterText.toLowerCase();
    return (
      item.title?.toLowerCase().includes(search) ||
      item.orderNo?.toLowerCase().includes(search) ||
      new Date(item.date).toLocaleDateString().toLowerCase().includes(search)
    );
  });

  const columns = [
    {
      name: "SN",
      selector: (row, index) => index + 1,
      width: "60px",
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
      grow: 2,
      wrap: false,
      cell: (row) => (
        <div
          style={{
            whiteSpace: "wrap-words",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
          }}
        >
          {row.title || "N/A"}
        </div>
      ),
    },
    {
      name: "Date(mm/dd/yyyy)",
      selector: (row) => row.date, 
      sortable: true,
      sortFunction: (a, b) => new Date(a.date) - new Date(b.date),
      cell: (row) => new Date(row.date).toLocaleDateString(),
    },

   {
        name: "Detail ",
        cell: (row) =>
          row.link ? (
            <a href={row.link} target="_blank" rel="noopener noreferrer">
              📄 Download
            </a>
          ) : (
            "-"
          ),
      }, 
  ];

  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <ClipLoader color="#123abc" loading={true} size={100} />
          <p>Fetching announcements... Please wait</p>
        </div>
      ) : (
        <>
    <header className="header-global">
  <Navbar
    className="navbar-main navbar-transparent navbar-light headroom"
    expand="lg"
    id="navbar-main"
  >
    <div className="nav-cont d-flex justify-content-center w-100">
      <NavbarBrand
        className="mr-lg-5 d-flex align-items-center"
        title="Go to iiitkota.ac.in"
        href="https://iiitkota.ac.in"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          alt="..."
          src={require("../assets/img/logo.png")}
          className="logo-nav w-25 w-md-25 w-sm-50"
          // style={{ width: "70px", height: "50px" }}
        />
        <div className="navbar-brand-head-kota">
          <h6 className="mb-0 ">भारतीय सूचना प्रौद्योगिकी संस्थान कोटा</h6>
          <h6 className="mb-0 ">Indian Institute of Information Technology Kota</h6>
          <h6 className="mb-0 ">(An Institute of National Importance under an Act of Parliament)</h6>
        </div>
      </NavbarBrand>
    </div>
  </Navbar>
</header>
          <div className="custom-table-container mt-5">
            <h2 className="mb-4 text-center">📄 Office Orders</h2>

            <div className="mb-3 d-flex justify-content-end">
              <input
                type="text"
                className="form-control custom-search"
                placeholder="🔍 Search announcements..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>

            <Tabs defaultActiveKey="officeOrders" id="announcement-tabs" className="mb-3">
              <Tab eventKey="officeOrders" title="Office Orders">
                <DataTable
                  columns={columns}
                  data={filteredOfficeOrders}
                  pagination
                  highlightOnHover
                  responsive
                  striped
                  defaultSortFieldId={1}
                  noDataComponent="😔 No office orders found"
                />
              </Tab>
              <Tab eventKey="otherAnnouncements" title="Other Announcements">
                <DataTable
                  columns={columns}
                  data={filteredOtherAnnouncements}
                  pagination
                  highlightOnHover
                  responsive
                  striped
                  defaultSortFieldId={1}
                  noDataComponent="😔 No other announcements found"
                />
              </Tab>
            </Tabs>
          </div>
        </>
      )}
    </>
  );
};

export default OfficeOrderTable;